/**
 * @generated SignedSource<<25b59468e838217794de416cb7a0d577>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type loginOnelogin_viewer$data = {
  readonly id: string;
  readonly actualPersonId: string | null;
  readonly " $fragmentType": "loginOnelogin_viewer";
};
export type loginOnelogin_viewer$key = {
  readonly " $data"?: loginOnelogin_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"loginOnelogin_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "loginOnelogin_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "actualPersonId",
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "3e90163c8d17543cca9f0f069e8f6e58";

export default node;
